module.exports = "/images/logo-large@3x.png?7f288d6995bc66adc77379e80637a9fd";